// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__m6y7o","errors":"Errors_errors__2zyTl"};